export default "__VITE_ASSET__DhXFp$iy__"